import { render, staticRenderFns } from "./FolderOpenIcon.vue?vue&type=template&id=1b16d2be&scoped=true&"
import script from "./FolderOpenIcon.vue?vue&type=script&lang=js&"
export * from "./FolderOpenIcon.vue?vue&type=script&lang=js&"
import style0 from "./FolderOpenIcon.vue?vue&type=style&index=0&id=1b16d2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16d2be",
  null
  
)

export default component.exports